/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import crypto from 'crypto';
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';
import QueryString from 'query-string';
import {
  mcdLoginUrl, clientId, returUrl, mcdLogoutUrl,
} from '../constants/Config';

export const getIdToken = () => {
  const cookie = new Cookies();
  const idToken = cookie.get('id_token');
  return idToken;
};

export const getAccessToken = () => {
  const accessToken = localStorage.getItem('access_token');
  return accessToken;
};

export const getLoginUrl = () => {
  const nonce = crypto.randomBytes(16).toString('base64');
//   const loginUrl = `${mcdLoginUrl}?client_id=${clientId}&redirect_uri=${returUrl}&scope=openid&response_type=id_token token&response_mode=fragment&nonce=${nonce}`;
  const loginUrl = `${mcdLoginUrl}?client_id=${clientId}&redirect_uri=${returUrl}&scope=openid api://6afcc29b-c524-4b21-85d2-18d8a647fbf4/access&response_type=id_token token&response_mode=fragment&nonce=${nonce}`;

  return loginUrl;
};

export const getLogoutUrl = (storeIdToken) => {
  let idToken = getIdToken();
  if (!idToken) {
    idToken = storeIdToken;
  }
  const logoutUrl = `${mcdLogoutUrl}?client_id=${clientId}&id_token_hint=${idToken}&post_logout_redirect_uri=${returUrl}`;
  return logoutUrl;
};

export const getUserData = () => {
  const userToken = getAccessToken();
  const userData = userToken ? jwtDecode(userToken) : '';
  return userData;
};

export const arrangeMenuArray = (listArray) => {
  const parsedHash = QueryString.parse(window.location.hash);
  const { fullReport } = parsedHash;
  const array = [];
  const others = [];
  for (let i = 0; i < listArray.length; i += 1) {
    if (listArray[i].Name.indexOf('||') > 0) {
      const parentObject = listArray[i].Name.split('||');
      const skipCheck = _.find(array, { Name: parentObject[1] });
      if (skipCheck) {
        // eslint-disable-next-line no-continue
        continue;
      }
      let childArray = [];
      if (parentObject[0] !== '0') {
        _.forEach(listArray, (newObject) => {
          const childObject = newObject.Name.split('||');
          if (parentObject[1] !== undefined && childObject[1] !== undefined && parentObject[1] === childObject[1]) {
            childArray.push({
              id: newObject.DashboardId,
              DashboardId: newObject.DashboardId,
              Name: childObject[3],
              order: childObject[2],
              description: childObject[4],
            });
          }
        });
      }
      const menuObject = {
        id: i + 1,
        Name: parentObject[1],
        DashboardId: childArray.length > 0 ? '' : listArray[i].DashboardId,
        order: parentObject[0],
        description: parentObject[4],
        children: _.orderBy(childArray, ['order'], 'asc'),
      };
      childArray = [];
      array.push(menuObject);
    } else {
      const reportObject = {
        id: i + 1,
        Name: listArray[i].Name,
        DashboardId: listArray[i].DashboardId,
        order: null,
        description: '',
      };
      others.push(reportObject);
    }
  }
  if (fullReport && others.length > 0) {
    const otherCategory = {
      id: listArray.length + 1,
      Name: 'Others',
      DashboardId: '',
      order: listArray.length + 1,
      description: '',
      children: others,
    };
    array.push(otherCategory);
  }
  return _.orderBy(array, ['order'], 'asc');
};

export const searchData = (dataArray) => {
  const parsedHash = QueryString.parse(window.location.hash);
  const { fullReport } = parsedHash;
  const data = [];
  _.forEach(dataArray, (dashboardObject) => {
    let dashboardName = dashboardObject.Name;
    let desc = '';
    if (fullReport && dashboardObject.Name.indexOf('||') <= 0) {
      dashboardName = dashboardObject.Name;
    } else {
      const splitArray = dashboardObject.Name.split('||');
      dashboardName = splitArray[0] === '0' ? splitArray[1] : splitArray[3];
      // eslint-disable-next-line prefer-destructuring
      desc = splitArray[4];
    }
    if (dashboardName) {
      const obj = {
        Name: dashboardName,
        DashboardId: dashboardObject.DashboardId,
        description: desc,
      };
      data.push(obj);
    }
  });
  return data;
};

// export const isAuthenticated = () => {
//   const cookie = new Cookies();
//   const aToken = localStorage.getItem('access_token');
//   const iToken = cookie.get('id_token');
//   if (iToken && aToken) {
//     const date = new Date();
//     const idTokenData = jwtDecode(iToken);
//     const accessTokenData = jwtDecode(aToken);
//     if (date.getTime() > idTokenData.exp * 1000 || idTokenData.exp !== accessTokenData.exp) {
//       console.log('Id token expiry is less than the current time');
//       return false;
//     }
//     return true;
//   }
//   return false;
// };

export const isAuthenticated = () => {
  const cookie = new Cookies();
  const aToken = localStorage.getItem('access_token');
  const iToken = cookie.get('id_token');
  if (iToken && aToken) {
    const date = new Date();
    const idTokenData = jwtDecode(iToken);
    const accessTokenData = jwtDecode(aToken);
    const CLOCK_SKEW_MS = 5 * 60 * 1000;
    if (date.getTime() > idTokenData.exp * 1000+CLOCK_SKEW_MS) { //|| idTokenData.exp !== accessTokenData.exp
      console.log('Id token expiry is less than the current time');
      return false;
    }
    return true;
  }
  return false;
};